export default {
    userIds: state => {
        return Object.keys(state.list).map(item => parseInt(item));
    }
}